const LAB_ID = 9;
const START_PATH = "/*";
const EXERCISE_SELECTION = "/Exercise";
const REPAIR = "/Repair";

const REPAIR_ADDRESS_FORM = "address-repair";
const REPAIR_DATE_REPAIR = "date-repair";
const REPAIR_NAV_BAR = "nav-repair";
const EXERCISE_SELECTION_DEFAULT = "selection";

const REPAIR_DATE_REPAIR_HEADING = "Repair Date Format";
const REPAIR_NAV_HEADING = "Repair Navigation Bar Format";
const REPAIR_ADDRESS_HEADING = "Repair Address Format";

const HEADINGS = {
  REPAIR_DATE_REPAIR_HEADING,
  REPAIR_NAV_HEADING,
  REPAIR_ADDRESS_HEADING,
};
const EXERCISE_STATES = {
  REPAIR_ADDRESS_FORM,
  REPAIR_DATE_REPAIR,
  REPAIR_NAV_BAR,
  EXERCISE_SELECTION_DEFAULT,
};

export {
  LAB_ID,
  START_PATH,
  EXERCISE_SELECTION,
  HEADINGS,
  REPAIR,
  EXERCISE_STATES,
};
